import React, { useEffect, useState } from "react";

import AccountsDetails from "./accountsDetails";

import SelectTargetAccount from "./selectTargetAccount";

import AddNewAccount from "./addNewAccount";

import { XMarkIcon } from "@heroicons/react/16/solid";
import { Badge } from "../../catalyst/badge";
import { Heading } from "../../catalyst/heading";
import LoadingMain from "../../components/LoadingMain";
import config from "../../config";
import Library from "./library";

export default function ConnectedAccounts() {
  const [showTransferTargetMenu, setShowTransferTargetMenu] = useState(false);

  const [transferData, setTransferData] = useState([]);

  const [connectedAccounts, setConnectedAccounts] = useState(null);
  const [loading, setLoading] = useState(true); // State to track loading state

  const params = new URLSearchParams(window.location.search);
  const [redirectMessage, setRedirectMessage] = useState(params.get("message"));
  const [addedAccount, setAddedAccount] = useState(() => {
    const accountParam = params.get("addedAccount");
    return accountParam !== null ? parseInt(accountParam, 10) : null;
  });
  const [selectedAccount, setSelectedAccount] = useState(
    addedAccount === null ? "" : addedAccount
  );

  const [alertOpen, setAlertOpen] = useState(redirectMessage != null);

  ///Get accounts
  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true); // Set loading state to true
        const user = JSON.parse(localStorage.getItem("user"));
        const response = await fetch(
          config.apiUrl + "/connectedAccount/" + user.id + "/list",
          {
            headers: {
              Authorization: "Bearer " + user.accessToken,
            },
          }
        );

        if (!response.ok) {
          throw new Error("Failed to fetch data");
        }
        const data = await response.json();
        setConnectedAccounts(data);
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false); // Set loading state to false after fetch completes
      }
    };

    fetchData(); // Call fetchData function when component mounts
  }, []); // Empty dependency array ensures useEffect runs only once

  function getAlertMessage() {
    switch (redirectMessage) {
      case "NO_YOUTUBE_CHANNEL":
        return "Please create a channel in your Youtube account to transfer playlists.";
      case "YOUTUBE_ADD_ERROR":
        return "Error in connecting youtube account. Please try again or contact us.";
      case "SPOTIFY_ADD_ERROR":
        return "Error in connecting Spotify account. Please try again or contact us.";
      case "APPLE_ADD_ERROR":
        return "Error in connecting Apple Music account. Please try again or contact us.";
      case "TIDAL_ADD_ERROR":
        return "Error in connecting Tidal account. Please try again or contact us.";
      case "FAILED_TO_DISCONNECT":
        return "Failed to disconnect. Please try again or contact us.";
      case "YOUTUBE_ADDED":
        return "Connected YouTube account.";
      case "SPOTIFY_ADDED":
        return "Connected Spotify account.";
      case "APPLE_ADDED":
        return "Connected Apple Music account.";
      case "TIDAL_ADDED":
        return "Connected Tidal account.";

      default:
        return "";
    }
  }
  function getAlertType() {
    switch (redirectMessage) {
      case "NO_YOUTUBE_CHANNEL":
        return "red";
      case "YOUTUBE_ADD_ERROR":
        return "red";
      case "SPOTIFY_ADD_ERROR":
        return "red";
      case "APPLE_ADD_ERROR":
        return "red";
      case "TIDAL_ADD_ERROR":
        return "red";
      case "FAILED_TO_DISCONNECT":
        return "red";
      case "YOUTUBE_ADDED":
        return "red";
      case "SPOTIFY_ADDED":
        return "lime";
      case "APPLE_ADDED":
        return "lime";
      case "TIDAL_ADDED":
        return "lime";

      default:
        return "";
    }
  }

  return (
    <>
      <>
        <div className="flex flex-wrap items-end justify-between gap-4">
          <div className="max-sm:w-full sm:flex-1">
            <Heading>Your Library</Heading>
            <div className="flex justify-end mt-5 mb-3">
              <AddNewAccount></AddNewAccount>
            </div>
          </div>
        </div>

        {showTransferTargetMenu ? (
          <>
            <SelectTargetAccount
              connectedAccounts={connectedAccounts}
              transferData={transferData}
              sourceAccountId={selectedAccount}
              setShowTransferTargetMenu={setShowTransferTargetMenu}
            ></SelectTargetAccount>
          </>
        ) : (
          <>
            {redirectMessage === null && !alertOpen ? (
              <></>
            ) : (
              <Badge color={getAlertType()}>
                {getAlertMessage()}
                <XMarkIcon
                  onClick={() => {
                    setRedirectMessage(null);
                    setAlertOpen(false);
                  }}
                  className="h-5 w-5 ml-auto"
                ></XMarkIcon>
              </Badge>
            )}

            {loading ? (
              <LoadingMain />
            ) : (
              <>
                <AccountsDetails
                  selectedAccount={selectedAccount}
                  onSelectedAccountChange={setSelectedAccount}
                  connectedAccounts={connectedAccounts}
                  defaultSelectText="Select Music Account"
                ></AccountsDetails>

                {selectedAccount === "" ? (
                  <>
                  
                  </>
                ) : (
                  //key={selectedAccount} to reset state say if things fail it still retains old account state
                  <Library
                    key={selectedAccount}
                    selectedAccount={selectedAccount}
                    setShowTransferTargetMenu={setShowTransferTargetMenu}
                    setTransferData={setTransferData}
                    connectedAccounts={connectedAccounts}
                  />
                )}
              </>
            )}
          </>
        )}
      </>
    </>
  );
}
